export default __webpack_public_path__ + "static/media/bakso_klangenan.cf73f704.png";